import { DtoMaterialesUtiRet } from '../../../Trabajos/Asignacion/Domain/DtoMaterialesUtiRet';

export class DtoDataMateriales extends DtoMaterialesUtiRet {
  CantidadDisponible: number = 0
  Lote: string = ''
  Bobina: string = ''
}